export enum PaymentsAnalyticsMessages {
  capability = 'payments',
  pageName = 'us foods:r4:invoices and payments',
  pageLoadedEvent = 'page loaded',
  sharePrintDownloadEvent = 'share print download',
  viewInvoicePageName = 'us foods:r4:invoice details', // Used to replace view-invoice page
  viewStatementsPageName = 'us foods:r4:invoice details',
  fileTypeBase = 'download:invoices:',
}
